export default "__VITE_ASSET__0e6dd076__"